import { createEntityAdapter } from '@reduxjs/toolkit';

import type { PeripheralListItem } from '~/common/models/peripheral.model';

export const peripheralsAdapter = createEntityAdapter<PeripheralListItem>({
  selectId: (peripheral: PeripheralListItem) => peripheral.id,
});
